import * as React from 'react';

import { FilterItemCheckbox } from '@notino/react-styleguide';

import { useTrackingContext } from '@context/tracking/TrackingContext';

import { VariantDisplay } from '../../../../FetchDoneBlock/ReviewItemDisplay/VariantDisplay';
import {
  useReviewFilterActions,
  useReviewFiltersStore,
} from '../../../Stores/filtersStore';
import { trackFiltration } from '../../tracking';

import { VariantsFilterContentWrapper } from './styled';

export const VariantsFilterContent: React.FC = () => {
  const filters = useReviewFiltersStore((state) => state.filtersData);
  const variants = filters?.variants || [];

  const selections = useReviewFiltersStore(
    (state) => state.temporarySelections
  );
  const { toggleSelection } = useReviewFilterActions();

  const { getTimeFromInit } = useTrackingContext();

  if (!variants.length) {
    return null;
  }

  const onChange = (id: number) => {
    toggleSelection(id);
    trackFiltration({
      interaction: 'click_add',
      timing: getTimeFromInit(),
      name: '',
      action: 'filtration_used',
      type: 'variant',
    });
  };

  return (
    <VariantsFilterContentWrapper>
      {variants
        .filter(({ count }) => (count ?? 0) > 0)
        .map(({ count, id }) => (
          <FilterItemCheckbox
            key={id}
            isChecked={selections.includes(id!)}
            onChange={() => onChange(id!)}
            count={count ?? undefined}
          >
            <VariantDisplay catalogId={String(id)} />
          </FilterItemCheckbox>
        ))}
    </VariantsFilterContentWrapper>
  );
};
